const inrFmt = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 });
const inr2 = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 });

export const hasData = (rows, keys) => (rows || []).some((r) => keys.some((k) => Number(r[k] || 0) !== 0));
export const uid = () => Math.random().toString(36).slice(2, 10);
export const withKeys = (arr = []) => arr.map((x) => (x._k ? x : { ...x, _k: uid() }));

export const inr = (v, exact = false) => (v == null ? "—" : (exact ? inr2 : inrFmt).format(Number(v)));
export const num = (v) => (v == null ? "—" : new Intl.NumberFormat("en-IN").format(Number(v)));
export const pct = (v) => (v == null ? "N/A" : `${v}%`);
export const fdate = (v) => {
  if (!v) return "—";
  const d = new Date(v.length === 10 ? `${v}T00:00:00` : v);
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric", timeZone: "Asia/Kolkata" });
};
export const fdatetime = (v) =>
  v ? new Date(v).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "Asia/Kolkata" }) : "—";
export const todayIST = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
export const compact = (v) => {
  const n = Number(v || 0);
  if (Math.abs(n) >= 1e7) return `₹${(n / 1e7).toFixed(1)}Cr`;
  if (Math.abs(n) >= 1e5) return `₹${(n / 1e5).toFixed(1)}L`;
  if (Math.abs(n) >= 1e3) return `₹${(n / 1e3).toFixed(1)}k`;
  return `₹${n.toFixed(0)}`;
};
